import { css, keyframes } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Table = styled('div')`
  border: 1px solid #ccc;
  border-bottom: 0;
  border-right: 0;
  position: relative;
`

export const TableHeader = styled('div')`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  font-weight: bold;
  background: #f8f8f8;
  border-bottom: 1px solid #ccc;
`

const fadeOutHighlight = keyframes`
  0% {
    background-color: #e3f2fd;
    opacity: 1;
  }
  85% {
    background-color: #e3f2fd;
    opacity: 1;
  }
  100% {
    background-color: #fff;
    opacity: 1;
  }
`

export const TableRow = styled('div')<{ isHighlighted?: boolean }>`
  display: grid;
  grid-template-columns: repeat(5, 20%);
  align-items: stretch;
  background: #fff;
  transition: background-color 0.3s;

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: #e3f2fd;
      animation: ${fadeOutHighlight} 1.5s ease forwards;
    `}
`

export const TableCell = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasBottomBorder',
})<{
  hasBottomBorder?: boolean
}>`
  padding: 10px 17px;
  border-right: 1px solid #ccc;
  border-bottom: ${({ hasBottomBorder }) => (hasBottomBorder ? '1px solid #ccc' : 'none')};
  min-height: 70px;
  display: flex;
  align-items: center;
`

export const TableLoadingOverlay = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`
